module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village/levelIcon//5_professional.png?v=f1fc57fd";